import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { MentorModel } from 'common/models/page-models/mentor/mentor-data-model';
import { MentorLogsListingModel, MentorLogsParams } from 'common/models/page-models/mentor-mapping/mentor-logs-model';



@Injectable({
    providedIn: 'root'
})
export class MentorLogDataService extends GridDataService<MentorLogsListingModel, MentorModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getStudentMentorAssignedLogData, http, ss);
    }

    createInstance(): MentorLogsListingModel {
        return new MentorLogsListingModel();
    }

    override getDeleteUrl(): string {
        return '';
    }

    override getGridParams(param): GridPostParams {
        return new MentorLogsParams();
    }

   
}
